var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1625 5.58067H16.4649C16.0072 5.58067 15.6277 5.20113 15.6277 4.74346C15.6277 4.28578 16.0072 3.90625 16.4649 3.90625H23.1625C23.6202 3.90625 23.9998 4.28578 23.9998 4.74346C23.9998 5.20113 23.6202 5.58067 23.1625 5.58067Z",
    fill: "#FF9F24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30233 5.58067H0.837209C0.379535 5.58067 0 5.20113 0 4.74346C0 4.28578 0.379535 3.90625 0.837209 3.90625H5.30233C5.76 3.90625 6.13954 4.28578 6.13954 4.74346C6.13954 5.20113 5.76 5.58067 5.30233 5.58067Z",
    fill: "#FF9F24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76731 9.48837C7.15522 9.48837 5.02312 7.35628 5.02312 4.74419C5.02312 2.13209 7.15522 0 9.76731 0C12.3794 0 14.5115 2.13209 14.5115 4.74419C14.5115 7.35628 12.3794 9.48837 9.76731 9.48837ZM9.76731 1.67442C8.07057 1.67442 6.69754 3.04744 6.69754 4.74419C6.69754 6.44093 8.07057 7.81395 9.76731 7.81395C11.4641 7.81395 12.8371 6.44093 12.8371 4.74419C12.8371 3.04744 11.4641 1.67442 9.76731 1.67442Z",
    fill: "#FF9F24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1631 17.86H18.698C18.2403 17.86 17.8608 17.4804 17.8608 17.0228C17.8608 16.5651 18.2403 16.1855 18.698 16.1855H23.1631C23.6208 16.1855 24.0003 16.5651 24.0003 17.0228C24.0003 17.4804 23.6208 17.86 23.1631 17.86Z",
    fill: "#FF9F24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53488 17.86H0.837209C0.379535 17.86 0 17.4804 0 17.0228C0 16.5651 0.379535 16.1855 0.837209 16.1855H7.53488C7.99256 16.1855 8.37209 16.5651 8.37209 17.0228C8.37209 17.4804 7.99256 17.86 7.53488 17.86Z",
    fill: "#FF9F24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2336 21.7677C11.6215 21.7677 9.48938 19.6356 9.48938 17.0235C9.48938 14.4114 11.6215 12.2793 14.2336 12.2793C16.8457 12.2793 18.9777 14.4114 18.9777 17.0235C18.9777 19.6356 16.8457 21.7677 14.2336 21.7677ZM14.2336 13.9537C12.5368 13.9537 11.1638 15.3267 11.1638 17.0235C11.1638 18.7202 12.5368 20.0932 14.2336 20.0932C15.9303 20.0932 17.3033 18.7202 17.3033 17.0235C17.3033 15.3267 15.9303 13.9537 14.2336 13.9537Z",
    fill: "#FF9F24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconOrange);
export default __webpack_public_path__ + "static/media/filterIconOrange.6bcb17ac62c02b1adebfeaac45814a91.svg";
export { ForwardRef as ReactComponent };